// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.l9wSLl {
  align-items: flex-start;
  background: var(--alert-info-background);
  border: 1px solid var(--status-info);
  border-radius: var(--radius-s);
  color: var(--text-neutral-dark);
  display: flex;
  gap: var(--spacing-1);
  padding: var(--spacing-1-5);
  margin-bottom: var(--spacing-1-5);
}

.MN4HQC {
  align-items: flex-start;
  background: var(--alert-error-background);
  border: 1px solid var(--status-error);
  border-radius: var(--radius-s);
  color: var(--text-neutral-dark);
  display: flex;
  gap: var(--spacing-1);
  padding: var(--spacing-1-5);
  margin-bottom: var(--spacing-1-5);
}

.mzss4Y {
  font-size: 16px;
  color: var(--status-info);
  flex-shrink: 0;
}

.MN4HQC .mzss4Y {
  color: var(--status-error);
}

.NhOmWS {
  flex: 1;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  color: var(--text-neutral-dark);
  letter-spacing: 0px;
  line-height: 20px;
}

.jXdXi1 {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
}

.a5Fr65 {
  font-size: 16px;
  color: var(--alert-info-close-icon-color);
}

.MN4HQC .a5Fr65 {
  color: var(--status-error);
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/RechargeDetailsModal/components/InvoiceAlert/InvoiceAlert.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,oCAAoC;EACpC,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;EACb,qBAAqB;EACrB,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,yCAAyC;EACzC,qCAAqC;EACrC,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;EACb,qBAAqB;EACrB,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,OAAO;EACP,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".alert {\n  align-items: flex-start;\n  background: var(--alert-info-background);\n  border: 1px solid var(--status-info);\n  border-radius: var(--radius-s);\n  color: var(--text-neutral-dark);\n  display: flex;\n  gap: var(--spacing-1);\n  padding: var(--spacing-1-5);\n  margin-bottom: var(--spacing-1-5);\n}\n\n.alertError {\n  align-items: flex-start;\n  background: var(--alert-error-background);\n  border: 1px solid var(--status-error);\n  border-radius: var(--radius-s);\n  color: var(--text-neutral-dark);\n  display: flex;\n  gap: var(--spacing-1);\n  padding: var(--spacing-1-5);\n  margin-bottom: var(--spacing-1-5);\n}\n\n.alertIcon {\n  font-size: 16px;\n  color: var(--status-info);\n  flex-shrink: 0;\n}\n\n.alertError .alertIcon {\n  color: var(--status-error);\n}\n\n.alertText {\n  flex: 1;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-dark);\n  letter-spacing: 0px;\n  line-height: 20px;\n}\n\n.alertClose {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 16px;\n  height: 16px;\n}\n\n.alertCloseIcon {\n  font-size: 16px;\n  color: var(--alert-info-close-icon-color);\n}\n\n.alertError .alertCloseIcon {\n  color: var(--status-error);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alert": `l9wSLl`,
	"alertError": `MN4HQC`,
	"alertIcon": `mzss4Y`,
	"alertText": `NhOmWS`,
	"alertClose": `jXdXi1`,
	"alertCloseIcon": `a5Fr65`
};
module.exports = ___CSS_LOADER_EXPORT___;
